import { render } from "./ServiceItsCardNormal.vue?vue&type=template&id=23cadd1c&scoped=true"
import script from "./ServiceItsCardNormal.vue?vue&type=script&lang=js"
export * from "./ServiceItsCardNormal.vue?vue&type=script&lang=js"

import "./ServiceItsCardNormal.vue?vue&type=style&index=0&id=23cadd1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23cadd1c"]])

export default __exports__